module.exports = __webpack_public_path__ + "img/79dc6f87f9b1294165c21a2acb2840e0.png";